import * as _ from 'lodash';
import * as R from 'ramda';
import { fromJS } from 'immutable';
import { fetchingState } from '@constants';

import * as economicUnitActions from '../actions/economicunits';
import { SUCCESS, START, ERROR } from '../actions/global';

const updateStateArrayItem = (state, action, arrayName, idFieldName) =>
  state.setIn(
    [arrayName, 'data'],
    fromJS(
      state
        .getIn([arrayName, 'data'])
        .toJS()
        .map(x =>
          x[idFieldName] === _.get(action, `data.results[0].${idFieldName}`)
            ? action.data.results[0]
            : x,
        ),
    ),
  );

const initialStats = {
  economicUnits: {
    data: [],
    state: null,
    pagination: {
      count: 0,
      page: 1,
      rowsPerPage: 50,
      rowsPerPageOptions: [25, 50, 100, 500, 1000, 5000, 10000],
    },
  },
  economicUnit: {
    data: {},
    state: null,
  },
  economicUnitProperties: {
    data: [],
    state: null,
  },
  economicUnitPropertyUses: {
    data: [],
    state: null,
  },
  economicUnitPropUseRentRolls: {
    data: [],
    state: null,
  },
  economicUnitRentRolls: {
    data: [],
    state: null,
  },
  economicUnitIncomeValuations: {
    data: [],
    state: null,
  },
  searchConfig: {
    data: [],
    state: null,
  },
  searchConfigs: {
    data: [],
    state: null,
  },
  searchParams: {
    data: [],
    state: null,
  },
  searchParam: {
    data: {},
    state: null,
  },
  codeFiles: {
    data: {},
    state: null,
  },
  validApproaches: {
    data: [],
    state: null,
  },
  incomeDirectCap: {
    data: {},
    state: null,
  },
  incomeDirectCapActuals: {
    data: {},
    state: null,
  },
  incomeDirectActualsPropertyUses: {
    data: [],
    state: null,
  },
  incomeDirectActualsExpenses: {
    data: [],
    state: null,
  },
  incomeDirectActualsAddlIncome: {
    data: [],
    state: null,
  },
  incomeDirectActualsAddlIncomeEGI: {
    data: [],
    state: null,
  },
  economicUnitPropertyValuations: {
    data: [],
    state: null,
  },
  economicUnitReconcile: {
    data: {},
    state: null,
  },
  events: { data: [], state: null, eventSearchValue: '' },
  eventFormOptions: { data: [], state: null },
  notes: { data: [], state: null },
  files: {},
  searchLastPayload: { data: {}, state: null },
  isRecalculating: null,
  overrideRentSummary: {
    data: [],
    state: null,
  },
  overrideRentRateTypes: {
    data: [],
    state: null
  },
  overrideRents: {
    data: [],
    state: null
  },
  selectedSearchYear: null,
  econUnitCodeList: {},
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case economicUnitActions.ECON_UNIT_CODES_FETCH_START: {
      return state.setIn(
        ['econUnitCodeList', action.codeType, action.name, 'state'],
        fetchingState.FETCHING,
      );
    }
    case economicUnitActions.ECON_UNIT_CODES_FETCH_SUCCESS: {
      const stateYear = state.get('selectedSearchYear');
      const actionYear = action.year;
      if(stateYear !== actionYear) {
        return state;
      }
      return state
        .setIn(
          ['econUnitCodeList', action.codeType, action.name, 'state'],
          fetchingState.LOADED,
        )
        .setIn(
          ['econUnitCodeList', action.codeType, action.name, 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case economicUnitActions.ECON_UNIT_CODES_FETCH_ERROR: {
      return state.setIn(
        ['econUnitCodeList', action.codeType, action.name, 'state'],
        fetchingState.ERROR,
      );
    }
    case economicUnitActions.SET_SELECTED_ECON_UNIT_SEARCH_YEAR:
      return state.setIn(['selectedSearchYear'], action.data);
    case economicUnitActions.ECONOMIC_UNITS_SEARCH[START]:
      return state
        .setIn(['economicUnits', 'state'], fetchingState.FETCHING)
        .setIn(['economicUnits', 'pagination', 'page'], action.page)
        .setIn(['economicUnits', 'pagination', 'rowsPerPage'], action.pageSize);
    case economicUnitActions.ECONOMIC_UNITS_SEARCH[SUCCESS]:
      let newState = state.setIn(
        ['economicUnits', 'state'],
        fetchingState.LOADED,
      );
      newState = newState.setIn(
        ['economicUnits', 'total'],
        fromJS(R.pathOr(0, ['data', 'totalProperty', 'econUnitCount'], action)),
      );
      newState = newState.setIn(
        ['economicUnits', 'pagination', 'count'],
        _.get(action, 'data.totalProperty.econUnitCount', 0),
      );
      return newState
        .setIn(
          ['economicUnits', 'data'],
          fromJS(R.pathOr([], ['data', 'results'], action)),
        )
        .setIn(
          ['searchLastPayload', 'data'],
          fromJS(_.get(action, 'payload', {})),
        );
    case economicUnitActions.ECONOMIC_UNITS_SEARCH[ERROR]:
      return state.setIn(['economicUnits', 'state'], fetchingState.ERROR);
    case economicUnitActions.ECONOMIC_UNIT_REFRESH_LAND[SUCCESS]:
      return state.setIn(
        ['economicUnit', 'data'],
        fromJS({
          ...state.getIn(['economicUnit', 'data']).toJS(),
          ...{
            landSizeAcres: _.get(action, 'data.results[0].landSizeAcres', 0),
            landSizeAcresUseable: _.get(action, 'data.results[0].landSizeAcresUseable', 0),
            landSizeSqft: _.get(action, 'data.results[0].landSizeSqft', 0),
            landSizeSqftUseable: _.get(action, 'data.results[0].landSizeSqftUseable', 0),
          }
        }),
      );
    case economicUnitActions.ECONOMIC_UNITS_SEARCH_CONFIG[START]:
      return state.setIn(['searchConfigs', 'state'], fetchingState.FETCHING);
    case economicUnitActions.ECONOMIC_UNITS_SEARCH_CONFIG[SUCCESS]:
      newState = state.setIn(['searchConfigs', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['searchConfigs', 'data'],
        fromJS(R.pathOr([], ['data', 'results'], action)),
      );
    case economicUnitActions.ECONOMIC_UNITS_SEARCH_CONFIG[ERROR]:
      return state.setIn(['searchConfigs', 'state'], fetchingState.ERROR);

    case economicUnitActions.ECONOMIC_UNITS_CREATE[SUCCESS]:
      newState = state.getIn(['economicUnits', 'data']).toJS();
      newState = newState.concat(action.data.results);
      return state.setIn(['economicUnits', 'data'], fromJS(newState));

    case economicUnitActions.ECONOMIC_UNIT_FETCH[START]:
      return state.setIn(['economicUnit', 'state'], fetchingState.FETCHING);

    case economicUnitActions.ECONOMIC_UNITS_UPDATE_DATA_INPUTS[SUCCESS]:
    case economicUnitActions.ECONOMIC_UNITS_UPDATE[SUCCESS]:
    case economicUnitActions.ECONOMIC_UNIT_FETCH[SUCCESS]:
      newState = state.setIn(['economicUnit', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['economicUnit', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case economicUnitActions.ECONOMIC_UNIT_FETCH[ERROR]:
      return state.setIn(['economicUnit', 'state'], fetchingState.ERROR);

    case economicUnitActions.ECONOMIC_UNIT_PROPERTY_FETCH[START]:
      return state.setIn(
        ['economicUnitProperties', 'state'],
        fetchingState.FETCHING,
      );
    case economicUnitActions.ECONOMIC_UNIT_PROPERTY_FETCH[SUCCESS]:
      newState = state.setIn(
        ['economicUnitProperties', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['economicUnitProperties', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case economicUnitActions.ECONOMIC_UNIT_PROPERTY_FETCH[ERROR]:
      return state.setIn(
        ['economicUnitProperties', 'state'],
        fetchingState.ERROR,
      );

    case economicUnitActions.ECONOMIC_UNIT_PROPERTY_INSERT[SUCCESS]:
      return state.setIn(
        ['economicUnitProperties', 'data'],
        fromJS([
          ...(state.getIn(['economicUnitProperties', 'data'])
            ? state.getIn(['economicUnitProperties', 'data']).toJS()
            : []),
          _.get(action, 'data.results[0]'),
        ]),
      );

    case economicUnitActions.ECONOMIC_UNIT_PROPERTY_DELETE[SUCCESS]:
      return state.setIn(
        ['economicUnitProperties', 'data'],
        fromJS(
          state
            .getIn(['economicUnitProperties', 'data'])
            .toJS()
            .filter(p => p.econPropID !== action.econPropId),
        ),
      );

    case economicUnitActions.ECONOMIC_UNIT_PROPERTY_USES_FETCH[START]:
      return state.setIn(
        ['economicUnitPropertyUses', 'state'],
        fetchingState.FETCHING,
      );
    case economicUnitActions.ECONOMIC_UNIT_PROPERTY_USES_FETCH[SUCCESS]:
      newState = state.setIn(
        ['economicUnitPropertyUses', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['economicUnitPropertyUses', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case economicUnitActions.ECONOMIC_UNIT_PROPERTY_USES_FETCH[ERROR]:
      return state.setIn(
        ['economicUnitPropertyUses', 'state'],
        fetchingState.ERROR,
      );

    case economicUnitActions.ECONOMIC_UNIT_RENT_ROLLS_FETCH[START]:
      return state.setIn(
        ['economicUnitRentRolls', 'state'],
        fetchingState.FETCHING,
      );
    case economicUnitActions.ECONOMIC_UNIT_RENT_ROLLS_FETCH[SUCCESS]:
      newState = state.setIn(
        ['economicUnitRentRolls', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['economicUnitRentRolls', 'data'],
        fromJS(action.data && action.data.results ? action.data.results : []),
      );
    case economicUnitActions.ECONOMIC_UNIT_RENT_ROLLS_FETCH[ERROR]:
      return state.setIn(
        ['economicUnitRentRolls', 'state'],
        fetchingState.ERROR,
      );

    case economicUnitActions.ECONOMIC_UNIT_PROPERTY_USE_UPDATE[SUCCESS]:
      return updateStateArrayItem(
        state,
        action,
        'economicUnitPropertyUses',
        'econPropUseID',
      );

    case economicUnitActions.ECONOMIC_UNIT_PROPERTY_USE_DELETE[SUCCESS]:
      return state.setIn(
        ['economicUnitPropertyUses', 'data'],
        fromJS(
          state
            .getIn(['economicUnitPropertyUses', 'data'])
            .toJS()
            .filter(p => p.econPropUseID !== action.econPropUseId),
        ),
      );

    case economicUnitActions.ECONOMIC_UNIT_PROPERTY_USE_INSERT[SUCCESS]:
      return state.setIn(
        ['economicUnitPropertyUses', 'data'],
        fromJS([
          ...(state.getIn(['economicUnitPropertyUses', 'data'])
            ? state.getIn(['economicUnitPropertyUses', 'data']).toJS()
            : []),
          _.get(action, 'data.results[0]'),
        ]),
      );
    case economicUnitActions.ECONOMIC_UNITS_SEARCH_PARAMS_FETCH[START]: {
      return state.setIn(['searchParams', 'state'], fetchingState.FETCHING);
    }
    case economicUnitActions.ECONOMIC_UNITS_SEARCH_PARAMS_FETCH[SUCCESS]: {
      return state
        .setIn(['searchParams', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchParams', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case economicUnitActions.ECONOMIC_UNITS_SEARCH_PARAMS_FETCH[ERROR]: {
      return state.setIn(['searchParams', 'state'], fetchingState.ERROR);
    }

    case economicUnitActions.ECONOMIC_UNITS_SEARCH_PARAM_INSERT[SUCCESS]:
    case economicUnitActions.ECONOMIC_UNITS_SEARCH_PARAM_UPDATE[SUCCESS]: {
      return state
        .setIn(['searchParam', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchParam', 'data'],
          fromJS(_.get(action, 'data.results.0', {})),
        );
    }

    case economicUnitActions.ECONOMIC_UNITS_SEARCH_PARAM_SET: {
      return state.setIn(
        ['searchParam', 'data'],
        fromJS(
          state
            .getIn(['searchParams', 'data'])
            .toJS()
            .find(v => v.searchParamID === action.searchParamID),
        ),
      );
    }

    case economicUnitActions.ECONOMIC_UNITS_SEARCH_PARAM_RESET: {
      return state.setIn(['searchParam', 'data'], fromJS({}));
    }

    case economicUnitActions.ECONOMIC_UNITS_SEARCH_CONFIG_FETCH[START]: {
      return state.setIn(['searchConfig', 'state'], fetchingState.FETCHING);
    }
    case economicUnitActions.ECONOMIC_UNITS_SEARCH_CONFIG_FETCH[SUCCESS]: {
      return state
        .setIn(['searchConfig', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchConfig', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case economicUnitActions.ECONOMIC_UNITS_SEARCH_CONFIG_FETCH[ERROR]: {
      return state.setIn(['searchConfig', 'state'], fetchingState.ERROR);
    }
    case economicUnitActions.CHANGE_PAGE: {
      return state.setIn(
        ['economicUnits', 'pagination', 'page'],
        action.payload,
      );
    }
    case economicUnitActions.CHANGE_ROWS_PER_PAGE: {
      return state.setIn(
        ['economicUnits', 'pagination', 'rowsPerPage'],
        action.payload,
      );
    }
    // EVENTS
    case economicUnitActions.UPDATE_ECONOMIC_UNIT_EVENT_SEARCH_VALUE: {
      return state.setIn(['events', 'eventSearchValue'], action.payload);
    }
    case economicUnitActions.FETCH_ECONOMIC_UNIT_EVENTS[START]: {
      return state
        .setIn(['events', 'data'], fromJS([]))
        .setIn(['events', 'state'], fetchingState.FETCHING);
    }
    case economicUnitActions.FETCH_ECONOMIC_UNIT_EVENTS[SUCCESS]: {
      return state
        .setIn(['events', 'state'], fetchingState.LOADED)
        .setIn(['events', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case economicUnitActions.FETCH_ECONOMIC_UNIT_EVENTS[ERROR]: {
      return state.setIn(['events', 'state'], fetchingState.ERROR);
    }
    case economicUnitActions.FETCH_ECONOMIC_UNIT_FORM_OPTIONS_EVENTS[START]: {
      return state
        .setIn(['eventFormOptions', 'data'], fromJS([]))
        .setIn(['eventFormOptions', 'state'], fetchingState.FETCHING);
    }
    case economicUnitActions.FETCH_ECONOMIC_UNIT_FORM_OPTIONS_EVENTS[SUCCESS]: {
      return state
        .setIn(['eventFormOptions', 'state'], fetchingState.LOADED)
        .setIn(
          ['eventFormOptions', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case economicUnitActions.FETCH_ECONOMIC_UNIT_FORM_OPTIONS_EVENTS[ERROR]: {
      return state.setIn(['eventFormOptions', 'state'], fetchingState.ERROR);
    }

    case economicUnitActions.ECONOMIC_UNIT_INCOME_VALUATIONS_FETCH[START]:
      return state.setIn(
        ['economicUnitIncomeValuations', 'state'],
        fetchingState.FETCHING,
      );
    case economicUnitActions.ECONOMIC_UNIT_INCOME_VALUATIONS_FETCH[SUCCESS]:
      newState = state.setIn(
        ['economicUnitIncomeValuations', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['economicUnitIncomeValuations', 'data'],
        fromJS(action.data && action.data.results ? action.data.results : []),
      );
    case economicUnitActions.ECONOMIC_UNIT_INCOME_VALUATIONS_FETCH[ERROR]:
      return state.setIn(
        ['economicUnitIncomeValuations', 'state'],
        fetchingState.ERROR,
      );

    case economicUnitActions.VALID_APPROACHES_FETCH[START]:
      return state.setIn(['validApproaches', 'state'], fetchingState.FETCHING);
    case economicUnitActions.VALID_APPROACHES_FETCH[SUCCESS]:
      newState = state.setIn(
        ['validApproaches', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['validApproaches', 'data'],
        fromJS(action.data && action.data.results ? action.data.results : []),
      );
    case economicUnitActions.VALID_APPROACHES_FETCH[ERROR]:
      return state.setIn(['validApproaches', 'state'], fetchingState.ERROR);

    // case economicUnitActions.ECONOMIC_UNIT_INCOME_VALUATION_CREATE[SUCCESS]:
    //   newState = state.getIn(['economicUnitIncomeValuations', 'data']).toJS();
    //   newState = newState.concat(action.data.results);
    //   return state.setIn(
    //     ['economicUnitIncomeValuations', 'data'],
    //     fromJS(newState),
    //   );

    case economicUnitActions.FETCH_CODE_FILE[SUCCESS]:
      return state.setIn(
        ['codeFiles', 'data', action.name],
        fromJS(action.data ? action.data.results : []),
      );

    case economicUnitActions.FETCH_INCOME_RATE_TYPES[SUCCESS]:
      return state.setIn(
        ['codeFiles', 'data', 'incomeRateTypes'],
        fromJS(action.data ? action.data.results : []),
      );

    case economicUnitActions.FETCH_INCOME_CALCULATION_RULE[SUCCESS]:
      return state.setIn(
        ['codeFiles', 'data', 'incomeCalculationRules'],
        fromJS(action.data ? action.data.results : []),
      );

    case economicUnitActions.FETCH_EXPENSE_CALCULATION_RULE[SUCCESS]:
      return state.setIn(
        ['codeFiles', 'data', 'expenseCalculationRules'],
        fromJS(action.data ? action.data.results : []),
      );

    case economicUnitActions.FETCH_LEASING_CONCESSIONS_CALCULATION_RULE[
      SUCCESS
    ]:
      return state.setIn(
        ['codeFiles', 'data', 'leasingConcenssionsCalculationRules'],
        fromJS(action.data ? action.data.results : []),
      );

    case economicUnitActions.FETCH_REIMBURSED_EXPENSE_CALCULATION_RULE[SUCCESS]:
      return state.setIn(
        ['codeFiles', 'data', 'reimbursedExpenseCalculationRules'],
        fromJS(action.data ? action.data.results : []),
      );

    case economicUnitActions.INCOME_DIRECT_CAP_FETCH[START]:
      return state.setIn(['incomeDirectCap', 'state'], fetchingState.FETCHING);
    case economicUnitActions.INCOME_DIRECT_CAP_UPDATE[SUCCESS]:
    case economicUnitActions.INCOME_DIRECT_CAP_FETCH[SUCCESS]:
      newState = state.setIn(
        ['incomeDirectCap', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['incomeDirectCap', 'data'],
        fromJS({
          ...state.getIn(['incomeDirectCap', 'data']).toJS(),
          ...(action.data && action.data.results
            ? { [action.data.results[0].pIncomeID]: action.data.results[0] }
            : {}),
        }),
      );
    case economicUnitActions.INCOME_DIRECT_CAP_FETCH[ERROR]:
      return state.setIn(['incomeDirectCap', 'state'], fetchingState.ERROR);

    case economicUnitActions.DELETE_DIRECT_CAP_MODEL[SUCCESS]: {
      const data = state.getIn(['incomeDirectCap', 'data']).toJS();
      delete data[action.pIncomeId];
      newState = state.setIn(['incomeDirectCap', 'data'], fromJS(data));
      return newState.setIn(
        ['economicUnitIncomeValuations', 'data'],
        fromJS(
          newState
            .getIn(['economicUnitIncomeValuations', 'data'])
            .toJS()
            .filter(v => v.pIncomeID !== action.pIncomeId),
        ),
      );
    }

    case economicUnitActions.INCOME_DIRECT_CAP_ACTUALS_FETCH[START]:
      return state.setIn(
        ['incomeDirectCapActuals', 'state'],
        fetchingState.FETCHING,
      );
    case economicUnitActions.INCOME_DIRECT_CAP_ACTUALS_UPDATE[SUCCESS]:
    case economicUnitActions.INCOME_DIRECT_CAP_ACTUALS_FETCH[SUCCESS]:
      newState = state.setIn(
        ['incomeDirectCapActuals', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['incomeDirectCapActuals', 'data'],
        fromJS({
          ...state.getIn(['incomeDirectCapActuals', 'data']).toJS(),
          ...(action.data && action.data.results
            ? { [action.data.results[0].pIncomeID]: action.data.results[0] }
            : {}),
        }),
      );
    case economicUnitActions.INCOME_DIRECT_CAP_ACTUALS_FETCH[ERROR]:
      return state.setIn(
        ['incomeDirectCapActuals', 'state'],
        fetchingState.ERROR,
      );

    case economicUnitActions.DELETE_DIRECT_CAP_ACTUALS[SUCCESS]: {
      const data = state.getIn(['incomeDirectCapActuals', 'data']).toJS();
      delete data[action.pIncomeId];
      newState = state.setIn(['incomeDirectCapActuals', 'data'], fromJS(data));
      return newState.setIn(
        ['economicUnitIncomeValuations', 'data'],
        fromJS(
          newState
            .getIn(['economicUnitIncomeValuations', 'data'])
            .toJS()
            .filter(v => v.pIncomeID !== action.pIncomeId),
        ),
      );
    }

    case economicUnitActions.UPDATE_INCOME_DIRECT_ACTUALS_NAME[SUCCESS]: {
      const currObj = state.getIn(['incomeDirectCapActuals', 'data']).toJS();
      return state.setIn(
        ['incomeDirectCapActuals', 'data', action.pIncomeId],
        fromJS({
          ...currObj[action.pIncomeId],
          updateDt: action.data.results[0].updateDt,
          valuationName: action.data.results[0].valuationName,
        }),
      );
    }

    case economicUnitActions.RECALCULATE_DIRECT_CAP_ACTUALS[SUCCESS]: {
      if(action.skipDataUpdate) {
        return state;
      }
      const {
        propertyUses,
        additionalIncome,
        additionalIncomeEGI,
        expenses,
        ...directCapActualData
      } = action.data.results || {};
      newState = state.setIn(
        ['incomeDirectActualsPropertyUses', 'data'],
        fromJS(propertyUses || []),
      );
      newState = newState.setIn(
        ['incomeDirectActualsExpenses', 'data'],
        fromJS(expenses || []),
      );
      newState = newState.setIn(
        ['incomeDirectActualsAddlIncome', 'data'],
        fromJS(additionalIncome || []),
      );
      newState = newState.setIn(
        ['incomeDirectActualsAddlIncomeEGI', 'data'],
        fromJS(additionalIncomeEGI || []),
      );

      const priorDirectCapActuals = state
        .getIn(['incomeDirectCapActuals', 'data'])
        .toJS();

      return newState.setIn(
        ['incomeDirectCapActuals', 'data'],
        fromJS({
          ...priorDirectCapActuals,
          ...{
            [action.pIncomeId]: {
              ...priorDirectCapActuals[action.pIncomeId],
              ...directCapActualData,
            },
          },
        }),
      );
    }

    case economicUnitActions.INCOME_DIRECT_ACTUALS_PROPERTY_USES_FETCH[START]:
      return state.setIn(
        ['incomeDirectActualsPropertyUses', 'state'],
        fetchingState.FETCHING,
      );
    case economicUnitActions.INCOME_DIRECT_ACTUALS_PROPERTY_USES_FETCH[SUCCESS]:
      newState = state.setIn(
        ['incomeDirectActualsPropertyUses', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['incomeDirectActualsPropertyUses', 'data'],
        fromJS(action.data && action.data.results ? action.data.results : []),
      );
    case economicUnitActions.INCOME_DIRECT_ACTUALS_PROPERTY_USES_FETCH[ERROR]:
      return state.setIn(
        ['incomeDirectActualsPropertyUses', 'state'],
        fetchingState.ERROR,
      );

    case economicUnitActions.INCOME_DIRECT_ACTUALS_EXPENSES_FETCH[START]:
      return state.setIn(
        ['incomeDirectActualsExpenses', 'state'],
        fetchingState.FETCHING,
      );
    case economicUnitActions.INCOME_DIRECT_ACTUALS_EXPENSES_FETCH[SUCCESS]:
      newState = state.setIn(
        ['incomeDirectActualsExpenses', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['incomeDirectActualsExpenses', 'data'],
        fromJS(action.data && action.data.results ? action.data.results : []),
      );
    case economicUnitActions.INCOME_DIRECT_ACTUALS_EXPENSES_FETCH[ERROR]:
      return state.setIn(
        ['incomeDirectActualsExpenses', 'state'],
        fetchingState.ERROR,
      );

    case economicUnitActions.INCOME_DIRECT_ACTUALS_ADDL_INCOME_FETCH[START]:
      return state.setIn(
        ['incomeDirectActualsAddlIncome', 'state'],
        fetchingState.FETCHING,
      );
    case economicUnitActions.INCOME_DIRECT_ACTUALS_ADDL_INCOME_FETCH[SUCCESS]:
      newState = state.setIn(
        ['incomeDirectActualsAddlIncome', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['incomeDirectActualsAddlIncome', 'data'],
        fromJS(action.data && action.data.results ? action.data.results : []),
      );
    case economicUnitActions.INCOME_DIRECT_ACTUALS_ADDL_INCOME_FETCH[ERROR]:
      return state.setIn(
        ['incomeDirectActualsAddlIncome', 'state'],
        fetchingState.ERROR,
      );

    case economicUnitActions.INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI_FETCH[START]:
      return state.setIn(
        ['incomeDirectActualsAddlIncomeEGI', 'state'],
        fetchingState.FETCHING,
      );
    case economicUnitActions.INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI_FETCH[
      SUCCESS
    ]:
      return state
        .setIn(
          ['incomeDirectActualsAddlIncomeEGI', 'state'],
          fetchingState.LOADED,
        )
        .setIn(
          ['incomeDirectActualsAddlIncomeEGI', 'data'],
          fromJS(action.data && action.data.results ? action.data.results : []),
        );
    case economicUnitActions.INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI_FETCH[ERROR]:
      return state.setIn(
        ['incomeDirectActualsAddlIncomeEGI', 'state'],
        fetchingState.ERROR,
      );

    case economicUnitActions.INSERT_INCOME_DIRECT_ACTUALS_PROPERTY_USE[SUCCESS]:
      return state.setIn(
        ['incomeDirectActualsPropertyUses', 'data'],
        fromJS([
          ...(state.getIn(['incomeDirectActualsPropertyUses', 'data'])
            ? state.getIn(['incomeDirectActualsPropertyUses', 'data']).toJS()
            : []),
          _.get(action, 'data.results[0]'),
        ]),
      );

    case economicUnitActions.DELETE_INCOME_DIRECT_ACTUALS_PROPERTY_USE[SUCCESS]:
      return state.setIn(
        ['incomeDirectActualsPropertyUses', 'data'],
        fromJS(
          state
            .getIn(['incomeDirectActualsPropertyUses', 'data'], [])
            .toJS()
            .filter(e => e.pPropertyUseID !== action.pPropertyUseId),
        ),
      );

    case economicUnitActions.UPDATE_INCOME_DIRECT_ACTUALS_PROPERTY_USE[SUCCESS]:
      return updateStateArrayItem(
        state,
        action,
        'incomeDirectActualsPropertyUses',
        'pPropertyUseID',
      );

    case economicUnitActions.INSERT_INCOME_DIRECT_ACTUALS_EXPENSE[SUCCESS]:
      return state.setIn(
        ['incomeDirectActualsExpenses', 'data'],
        fromJS([
          ...(state.getIn(['incomeDirectActualsExpenses', 'data'])
            ? state.getIn(['incomeDirectActualsExpenses', 'data']).toJS()
            : []),
          _.get(action, 'data.results[0]'),
        ]),
      );

    case economicUnitActions.DELETE_INCOME_DIRECT_ACTUALS_EXPENSE[SUCCESS]:
      return state.setIn(
        ['incomeDirectActualsExpenses', 'data'],
        fromJS(
          state
            .getIn(['incomeDirectActualsExpenses', 'data'], [])
            .toJS()
            .filter(e => e.pExpenseID !== action.pExpenseId),
        ),
      );

    case economicUnitActions.UPDATE_INCOME_DIRECT_ACTUALS_EXPENSE[SUCCESS]:
      return updateStateArrayItem(
        state,
        action,
        'incomeDirectActualsExpenses',
        'pExpenseID',
      );

    case economicUnitActions.INSERT_INCOME_DIRECT_ACTUALS_ADDL_INCOME[SUCCESS]:
      return state.setIn(
        ['incomeDirectActualsAddlIncome', 'data'],
        fromJS([
          ...(state.getIn(['incomeDirectActualsAddlIncome', 'data'])
            ? state.getIn(['incomeDirectActualsAddlIncome', 'data']).toJS()
            : []),
          _.get(action, 'data.results[0]'),
        ]),
      );

    case economicUnitActions.UPDATE_INCOME_DIRECT_ACTUALS_ADDL_INCOME[SUCCESS]:
      return updateStateArrayItem(
        state,
        action,
        'incomeDirectActualsAddlIncome',
        'pAddIncomeID',
      );

    case economicUnitActions.DELETE_INCOME_DIRECT_ACTUALS_ADDL_INCOME[SUCCESS]:
      return state.setIn(
        ['incomeDirectActualsAddlIncome', 'data'],
        fromJS(
          state
            .getIn(['incomeDirectActualsAddlIncome', 'data'], [])
            .toJS()
            .filter(e => e.pAddIncomeID !== action.pAddIncomeId),
        ),
      );

    case economicUnitActions.INSERT_INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI[
      SUCCESS
    ]:
      return state.setIn(
        ['incomeDirectActualsAddlIncomeEGI', 'data'],
        fromJS([
          ...(state.getIn(['incomeDirectActualsAddlIncomeEGI', 'data'])
            ? state.getIn(['incomeDirectActualsAddlIncomeEGI', 'data']).toJS()
            : []),
          _.get(action, 'data.results[0]'),
        ]),
      );

    case economicUnitActions.UPDATE_INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI[
      SUCCESS
    ]:
      return updateStateArrayItem(
        state,
        action,
        'incomeDirectActualsAddlIncomeEGI',
        'pAddIncomeID',
      );

    case economicUnitActions.DELETE_INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI[
      SUCCESS
    ]:
      return state.setIn(
        ['incomeDirectActualsAddlIncomeEGI', 'data'],
        fromJS(
          state
            .getIn(['incomeDirectActualsAddlIncomeEGI', 'data'], [])
            .toJS()
            .filter(e => e.pAddIncomeID !== action.pAddIncomeId),
        ),
      );

    case economicUnitActions.FETCH_ECONOMIC_UNIT_NOTES[START]:
      return state.setIn(['notes', 'state'], fetchingState.FETCHING);
    case economicUnitActions.FETCH_ECONOMIC_UNIT_NOTES[SUCCESS]:
      newState = state.setIn(['notes', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['notes', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case economicUnitActions.FETCH_ECONOMIC_UNIT_NOTES[ERROR]:
      return state.setIn(['notes', 'state'], fetchingState.ERROR);

    case economicUnitActions.ADD_ECONOMIC_UNIT_NOTE[SUCCESS]:
      let newNotes = state.getIn(['notes', 'data']).toJS();
      newNotes = newNotes.concat(action.data.results);
      return state.setIn(['notes', 'data'], fromJS(newNotes));

    case economicUnitActions.UPDATE_ECONOMIC_UNIT_NOTE[SUCCESS]:
      newNotes = state.getIn(['notes', 'data']).toJS();
      newNotes = newNotes.filter(n => n.noteID !== action.noteId);
      newNotes = newNotes.concat(action.data.results);
      return state.setIn(['notes', 'data'], fromJS(newNotes));

    case economicUnitActions.INSERT_ECONOMIC_UNIT_FILE[START]: {
      return state.setIn(['files', 'state'], fetchingState.FETCHING);
    }
    case economicUnitActions.INSERT_ECONOMIC_UNIT_FILE[SUCCESS]: {
      return state.setIn(['files', 'state'], fetchingState.LOADED);
    }
    case economicUnitActions.INSERT_ECONOMIC_UNIT_FILE[ERROR]: {
      return state.setIn(['files', 'state'], fetchingState.ERROR);
    }

    case economicUnitActions.DELETE_ECONOMIC_UNIT_FILE[START]: {
      return state.setIn(['files', 'state'], fetchingState.FETCHING);
    }
    case economicUnitActions.DELETE_ECONOMIC_UNIT_FILE[SUCCESS]: {
      return state.setIn(['files', 'state'], fetchingState.LOADED);
    }
    case economicUnitActions.DELETE_ECONOMIC_UNIT_FILE[ERROR]: {
      return state.setIn(['files', 'state'], fetchingState.ERROR);
    }
    case economicUnitActions.UPDATE_ECONOMIC_UNIT_FILE[START]: {
      return state.setIn(['files', 'state'], fetchingState.FETCHING);
    }
    case economicUnitActions.UPDATE_ECONOMIC_UNIT_FILE[SUCCESS]: {
      return state.setIn(['files', 'state'], fetchingState.LOADED);
    }
    case economicUnitActions.UPDATE_ECONOMIC_UNIT_FILE[ERROR]: {
      return state.setIn(['files', 'state'], fetchingState.ERROR);
    }

    case economicUnitActions.FETCH_ECONOMIC_UNIT_PROPERTY_VALUATIONS[START]:
      return state.setIn(
        ['economicUnitPropertyValuations', 'state'],
        fetchingState.FETCHING,
      );
    case economicUnitActions.FETCH_ECONOMIC_UNIT_PROPERTY_VALUATIONS[SUCCESS]:
      newState = state.setIn(
        ['economicUnitPropertyValuations', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['economicUnitPropertyValuations', 'data'],
        fromJS(action.data && action.data.results ? action.data.results : []),
      );
    case economicUnitActions.FETCH_ECONOMIC_UNIT_PROPERTY_VALUATIONS[ERROR]:
      return state.setIn(
        ['economicUnitPropertyValuations', 'state'],
        fetchingState.ERROR,
      );

    case economicUnitActions.INCLUDE_ECONOMIC_UNIT_PROPERTY_VALUATION[SUCCESS]:
      return state.setIn(
        ['economicUnitPropertyValuations', 'data', 'valuations'],
        fromJS(
          state
            .getIn(['economicUnitPropertyValuations', 'data', 'valuations'])
            .toJS()
            .map(x =>
              x.pValuationID === _.get(action, 'data.results[0].pValuationID')
                ? { ...x, includedValuation: 1 }
                : x,
            ),
        ),
      );

    case economicUnitActions.EXCLUDE_ECONOMIC_UNIT_PROPERTY_VALUATION[SUCCESS]:
      return state.setIn(
        ['economicUnitPropertyValuations', 'data', 'valuations'],
        fromJS(
          state
            .getIn(['economicUnitPropertyValuations', 'data', 'valuations'])
            .toJS()
            .map(x =>
              x.econIncludedValuationID === action.econIncludedValuationId
                ? { ...x, includedValuation: 0 }
                : x,
            ),
        ),
      );

    case economicUnitActions.FETCH_ECONOMIC_UNIT_RECONCILE[START]:
      return state.setIn(
        ['economicUnitReconcile', 'state'],
        fetchingState.FETCHING,
      );
    case economicUnitActions.UPDATE_ECONOMIC_UNIT_RECONCILE[SUCCESS]:
    case economicUnitActions.FETCH_ECONOMIC_UNIT_RECONCILE[SUCCESS]:
      newState = state.setIn(
        ['economicUnitReconcile', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['economicUnitReconcile', 'data'],
        fromJS(
          action.data && action.data.results ? action.data.results[0] : {},
        ),
      );
    case economicUnitActions.FETCH_ECONOMIC_UNIT_RECONCILE[ERROR]:
      return state.setIn(
        ['economicUnitReconcile', 'state'],
        fetchingState.ERROR,
      );

    case economicUnitActions.FETCH_ECONOMIC_UNIT_ALLOCATE[START]:
      return state.setIn(
        ['economicUnitAllocate', 'state'],
        fetchingState.FETCHING,
      );
    case economicUnitActions.UPDATE_ECONOMIC_UNIT_ALLOCATE[SUCCESS]:
    case economicUnitActions.FETCH_ECONOMIC_UNIT_ALLOCATE[SUCCESS]:
      newState = state.setIn(
        ['economicUnitAllocate', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['economicUnitAllocate', 'data'],
        fromJS(
          action.data && action.data.results ? action.data.results[0] : {},
        ),
      );
    case economicUnitActions.FETCH_ECONOMIC_UNIT_ALLOCATE[ERROR]:
      return state.setIn(
        ['economicUnitAllocate', 'state'],
        fetchingState.ERROR,
      );

    case economicUnitActions.FETCH_ECONOMIC_UNIT_DISTRIBUTION[START]:
      return state.setIn(
        ['economicUnitDistribution', 'state'],
        fetchingState.FETCHING,
      );
    case economicUnitActions.UPDATE_ECONOMIC_UNIT_DISTRIBUTION[SUCCESS]:
    case economicUnitActions.FETCH_ECONOMIC_UNIT_DISTRIBUTION[SUCCESS]:
      newState = state.setIn(
        ['economicUnitDistribution', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['economicUnitDistribution', 'data'],
        fromJS(action.data && action.data.results ? action.data.results : {}),
      );
    case economicUnitActions.FETCH_ECONOMIC_UNIT_DISTRIBUTION[ERROR]:
      return state.setIn(
        ['economicUnitDistribution', 'state'],
        fetchingState.ERROR,
      );
    case economicUnitActions.UPDATE_MARKET_AREA_TAX_RATE[SUCCESS]:
      newState = state.setIn(['economicUnit', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['economicUnit', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );

    case economicUnitActions.UPDATE_MARKET_AREA_TAX_RATE_LOAD[SUCCESS]:
      newState = state.setIn(['economicUnit', 'state'], fetchingState.LOADED);
      const projectedTaxLoad = action.data
        ? action.data.results[0].projectedTaxLoad
        : '0.0';
      return newState.setIn(
        ['economicUnit', 'data', 'projectedTaxLoad'],
        projectedTaxLoad,
      );

    case economicUnitActions.FETCH_ECONOMIC_UNIT_PROPUSE_RENT_ROLLS[START]:
      return state.setIn(
        ['economicUnitPropUseRentRolls', 'state'],
        fetchingState.FETCHING,
      );
    case economicUnitActions.FETCH_ECONOMIC_UNIT_PROPUSE_RENT_ROLLS[SUCCESS]:
      newState = state.setIn(
        ['economicUnitPropUseRentRolls', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['economicUnitPropUseRentRolls', 'data'],
        fromJS(action.data && action.data.results ? action.data.results : []),
      );
    case economicUnitActions.FETCH_ECONOMIC_UNIT_PROPUSE_RENT_ROLLS[ERROR]:
      return state.setIn(
        ['economicUnitPropUseRentRolls', 'state'],
        fetchingState.ERROR,
      );
    case economicUnitActions.ECONOMIC_UNIT_RECALCULATE[START]:
      return state.setIn(['isRecalculating'], fetchingState.FETCHING);
    case economicUnitActions.ECONOMIC_UNIT_RECALCULATE[SUCCESS]:
      return state.setIn(['isRecalculating'], fetchingState.LOADED);
    case economicUnitActions.ECONOMIC_UNIT_RECALCULATE[ERROR]:
      return state.setIn(['isRecalculating'], fetchingState.ERROR);
    case economicUnitActions.FETCH_OVERRIDE_RENT_SUMMARY[START]:
      return state.setIn(
        ['overrideRentSummary', 'state'],
        fetchingState.FETCHING,
      );
    case economicUnitActions.FETCH_OVERRIDE_RENT_SUMMARY[SUCCESS]:
      newState = state.setIn(
        ['overrideRentSummary', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['overrideRentSummary', 'data'],
        fromJS(action.data && action.data.results ? action.data.results : []),
      );
    case economicUnitActions.FETCH_OVERRIDE_RENT_SUMMARY[ERROR]:
      return state.setIn(
        ['overrideRentSummary', 'state'],
        fetchingState.ERROR,
      );
    case economicUnitActions.FETCH_OVERRIDE_RENT_RATE_TYPES[START]:
      return state.setIn(
        ['overrideRentRateTypes', 'state'],
        fetchingState.FETCHING,
      );
    case economicUnitActions.FETCH_OVERRIDE_RENT_RATE_TYPES[SUCCESS]:
      newState = state.setIn(
        ['overrideRentRateTypes', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['overrideRentRateTypes', 'data'],
        fromJS(action.data && action.data.results ? action.data.results : []),
      );
    case economicUnitActions.FETCH_OVERRIDE_RENT_RATE_TYPES[ERROR]:
      return state.setIn(
        ['overrideRentRateTypes', 'state'],
        fetchingState.ERROR,
      );
    case economicUnitActions.FETCH_OVERRIDE_RENTS[START]:
      return state.setIn(
        ['overrideRents', 'state'],
        fetchingState.FETCHING,
      );
    case economicUnitActions.FETCH_OVERRIDE_RENTS[SUCCESS]:
      newState = state.setIn(
        ['overrideRents', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['overrideRents', 'data'],
        fromJS(action.data && action.data.results ? action.data.results : []),
      );
    case economicUnitActions.FETCH_OVERRIDE_RENTS[ERROR]:
      return state.setIn(
        ['overrideRents', 'state'],
        fetchingState.ERROR,
      );
    default:
      return state;
  }
};
